module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_mobile_04@2x-f9073eae8e8ded8a51407cc308b9bab3.jpg";